var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBetatesterIconWarn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.75 30C58.75 14.122 45.878 1.25 30 1.25S1.25 14.122 1.25 30c0 15.877 12.872 28.75 28.75 28.75S58.75 45.877 58.75 30zM60 30c0 16.566-13.431 30-30 30C13.431 60 0 46.566 0 30 0 13.432 13.431 0 30 0c16.569 0 30 13.432 30 30zM29.119 15.625a.875.875 0 0 1 1.75 0V33.75a.875.875 0 1 1-1.75 0V15.625zm2.444 25.936c0 .862-.699 1.565-1.565 1.565-.86 0-1.56-.703-1.56-1.565a1.561 1.561 0 1 1 3.125 0z"
  })));
}
export default SvgBetatesterIconWarn;